import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { ContentImpl } from "./content.styles.es.js";
import { deprecated } from "../../../prop-types-validators/deprecated.es.js";
const borderPlacementType = PropTypes.oneOf(["bottom", "left", "right", "top"]);
const paddingType = PropTypes.oneOf([
  "none",
  "xsmall",
  "small",
  "medium",
  "large",
  "xlarge"
]);
const propTypes = {
  align: PropTypes.oneOf(["center", "end", "start", "stretch"]),
  alignX: PropTypes.oneOf(["center", "left", "right", "stretch"]),
  alignY: PropTypes.oneOf(["bottom", "center", "stretch", "top"]),
  appearance: PropTypes.oneOf(["dark", "none", "light"]),
  borderPlacement: PropTypes.oneOfType([
    borderPlacementType,
    PropTypes.arrayOf(borderPlacementType)
  ]),
  borderRadiusSize: PropTypes.oneOf(["none", "xsmall", "small"]),
  children: PropTypes.node.isRequired,
  flex: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  justify: deprecated(
    PropTypes.oneOf([
      "center",
      "end",
      "space-around",
      "space-between",
      "space-evenly",
      "start"
    ]),
    "Use alignX prop instead."
  ),
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  overflow: PropTypes.oneOf(["auto", "hidden", "visible"]),
  padding: paddingType,
  paddingBottom: paddingType,
  paddingX: paddingType,
  paddingY: paddingType,
  spacing: deprecated(
    PropTypes.oneOf(["medium", "none", "small"]),
    "Use padding prop instead."
  ),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
const defaultProps = {
  align: void 0,
  alignX: "stretch",
  alignY: "stretch",
  appearance: "none",
  borderPlacement: void 0,
  borderRadiusSize: "none",
  flex: void 0,
  height: void 0,
  justify: void 0,
  maxHeight: void 0,
  overflow: "auto",
  padding: "medium",
  paddingBottom: void 0,
  paddingX: void 0,
  paddingY: void 0,
  spacing: void 0,
  width: "100%"
};
const Content = forwardRef(
  ({
    align,
    alignX,
    alignY,
    appearance,
    borderPlacement,
    borderRadiusSize,
    children,
    flex,
    height,
    justify,
    maxHeight,
    overflow,
    padding,
    paddingBottom,
    paddingX,
    paddingY,
    spacing,
    width,
    ...restProps
  }, forwardedRef) => /* @__PURE__ */ jsx(
    ContentImpl,
    {
      ref: forwardedRef,
      $align: align,
      $alignX: alignX,
      $alignY: alignY,
      $appearance: appearance,
      $borderPlacement: borderPlacement,
      $borderRadiusSize: borderRadiusSize,
      $flex: flex,
      $height: height,
      $justify: justify,
      $maxHeight: maxHeight,
      $overflow: overflow,
      $paddingBottom: paddingBottom || paddingY || padding,
      $paddingX: paddingX || padding,
      $paddingY: paddingY || padding,
      $spacing: spacing,
      $width: width,
      ...restProps,
      children: /* @__PURE__ */ jsx("div", { children })
    }
  )
);
Content.propTypes = propTypes;
Content.defaultProps = defaultProps;
export {
  Content
};
